// @ts-expect-error not typed

import ContentRoutes from 'ContentUtils/Routes';
import { getIsConvertibleToDragAndDrop } from 'EmailData/utils/emailStateUtil';
import { trackFrameworkTableInteraction } from 'EmailData/utils/tracking';
import CloneOrConvertModal from 'email-management-lib/EmailClone/components/CloneOrConvertModal';
import useCloneEmail from 'email-management-lib/EmailClone/hooks/useCloneEmail';
import useEmailCloneInfo from 'email-management-lib/EmailClone/hooks/useEmailCloneInfo';
import { handleCloneError } from 'email-management-lib/EmailClone/utils/errorMessaging';
import useAvailableEmailTypes from 'email-management-lib/EmailCreation/hooks/useAvailableEmailTypes';
import useGetAreEmailTypesAvailable from 'email-management-lib/EmailCreation/hooks/useGetAreEmailTypesAvailable';
import useEmailDetails from 'email-management-lib/Shared/hooks/useEmailDetails';
import { openURL } from 'email-management-lib/Shared/utils/navigation';
import useUserInfo from 'messaging-management-lib/user/hooks/useUserInfo';
import { useCallback, useMemo } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
function EmailCloneContainer({
  email,
  crmObject,
  onClose
}) {
  var _emailDetails$variant, _emailDetails$variant2;
  const cloneEmail = useCloneEmail({
    onCompleted(data) {
      openURL({
        url: ContentRoutes.editEmail(data.id)
      });
    },
    onError: handleCloneError
  });
  const checkIfConvertibleToDragAndDrop = getIsConvertibleToDragAndDrop(email);
  const {
    hasScope,
    isUngatedFor
  } = useUserInfo();
  const {
    emailDetails
  } = useEmailDetails({
    emailId: email.id,
    skip: !email.isABLike()
  });
  const {
    hasCustomPlaintext,
    isCloneDataErrored,
    isConvertible,
    isCloneDataReady,
    smartContentLocations,
    variantSmartContentLocations,
    variantHasCustomPlaintext
  } = useEmailCloneInfo({
    emailId: email.id,
    variantId: (_emailDetails$variant = emailDetails === null || emailDetails === void 0 || (_emailDetails$variant2 = emailDetails.variant) === null || _emailDetails$variant2 === void 0 ? void 0 : _emailDetails$variant2.id) !== null && _emailDetails$variant !== void 0 ? _emailDetails$variant : undefined,
    checkIfConvertibleToDragAndDrop
  });
  const availableEmailTypes = useAvailableEmailTypes();
  const areEmailTypesAvailable = useGetAreEmailTypesAvailable();
  const canAccessBusinessUnit = useMemo(() => {
    return hasScope('business-units-access') && isUngatedFor('campaign-business-unit');
  }, [hasScope, isUngatedFor]);
  const hasAutomatedAccess = areEmailTypesAvailable(['AUTOMATED_EMAIL']);
  const hasEmailAccess = useMemo(() => {
    return hasScope('email-access');
  }, [hasScope]);
  const confirmClone = useCallback((emailId, options) => {
    void cloneEmail({
      id: emailId,
      options
    });
    trackFrameworkTableInteraction({
      otherActions: 'confirm-clone'
    });
    trackFrameworkTableInteraction({
      otherActions: `clone_email_custom_properties_${options.customProperties && options.customProperties.length > 0 ? 'true' : 'false'}`
    });
    trackFrameworkTableInteraction({
      otherActions: `clone_email_permissions_${options.retainPermissionsAfterClone}`
    });
    trackFrameworkTableInteraction({
      otherActions: `clone_email_smart_content_${options.cloneWithSmartContent}`
    });
    trackFrameworkTableInteraction({
      otherActions: `clone_email_plaintext_${options.cloneWithCustomPlaintext}`
    });
  }, [cloneEmail]);
  return /*#__PURE__*/_jsx(CloneOrConvertModal, {
    availableEmailTypes: availableEmailTypes,
    canAccessBusinessUnit: canAccessBusinessUnit,
    confirmClone: confirmClone,
    crmObject: crmObject,
    email: email,
    emailDetails: emailDetails,
    hasAutomatedAccess: hasAutomatedAccess,
    hasCustomPlaintext: hasCustomPlaintext,
    isCloneDataReady: isCloneDataReady,
    isCloneDataErrored: isCloneDataErrored,
    isConvertible: isConvertible,
    onClose: onClose,
    smartContentLocations: smartContentLocations,
    userCanCreateClassicEmail: hasEmailAccess,
    variantSmartContentLocations: variantSmartContentLocations,
    variantHasCustomPlaintext: variantHasCustomPlaintext
  });
}
export default EmailCloneContainer;